import { AIBadgeScore as AntdAIBadgeScore } from "@empglabs/backoffice-ui-kit"

export const AIBadgeScore = props => {
  return <AntdAIBadgeScore {...props} />
}
